import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import SendMaterialToPatient from "./SendEducationMaterial";
import { useFetch2 } from "components/utils/authenticatedHook";
import EducationPatientList from "./EducationPatientsList";
import { pasteValue } from "../Reusable/OnPasteValue";

function EducationMaterialSentPatients(props) {
    const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
    const [sendModal, setSendModal] = useState(false);
    const [reload, setReload] = useState(false);

    function handelToggleModal(event) {
        setSendModal(!sendModal);
        if (event == "reload") {
            setReload(true)
            getEducationMaterialPatients();
        }
    }
    function getEducationMaterialPatients(filter) {
        const query = {
            page: filter?.page ?? 1,
            limit: filter?.limit ?? 25,
            sortOrder: filter?.sortOrder ?? "desc",
            sortFiled: filter?.sortFiled ?? "educationMaterialLastNoteDate",
        };
        if (filter && filter.search) {
            query.search = filter.search;
        }
        doFetch({
            url: "/get-education-material-send-patients",
            method: "GET",
            disableWait: true,
            query: query,
        });
    }
    function paginationEducationList(type, { page, sizePerPage, filters, sortField, sortOrder }) {
        let data = { page: page, limit: sizePerPage };
        if (sortField) {
            data.sortFiled = sortField;
        }
        if (sortOrder) {
            data.sortOrder = sortOrder;
        }
        getEducationMaterialPatients(data);
    }
    let debounceTimeout;
    function handleSearch(event) {
        const value = event.target.value;

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            getEducationMaterialPatients({ search: value });
        }, 500);
    }
    useEffect(() => { getEducationMaterialPatients() }, [])

    useEffect(() => {
        if(reload && response && response.educationMaterialPatients && response.educationMaterialPatients.totalCount){
         setReload(false);
         props.updateEducationCount(response.educationMaterialPatients.totalCount);
        }
    }, [response])

    return (
        <Row className="col-sm-12 main-cls-modal remove-table-padding mt-2">
            <Col sm="12" className="mt-12">
                <div>
                    <div
                        className="d-flex w-100 align-items-start"
                        style={{ marginTop: "2%" }}
                    >
                        <input
                            type="text"
                            className="form-control input-date-filter remove-bottom-margin mb-2 mr-3 w-75"
                            id="exampleInputName1Test"
                            style={{ fontSize: "20px", flex: 1 }}
                            placeholder="Search name, main careprovider, organization..."
                            onChange={handleSearch} // Call handleChange on every input change
                            onPaste={(e) => {
                                e.preventDefault();
                                const event = pasteValue(e);
                                handleSearch(event);
                            }}
                        />
                        <button
                            className="btn btn-success text-white"
                            onClick={() => {
                                setSendModal(true);
                            }}
                            style={{borderRadius:'10px', paddingLeft : '15px', paddingRight : '15px'}}
                        >
                           <i className="mdi mdi-file-send-outline mr-1" style={{ fontSize: 17 }}></i> Send Educational Material
                        </button>
                    </div>
                </div>
            </Col>
            <Col sm="12">
                <div className="w-100" style={{ marginTop: '20px' }}>
                    <EducationPatientList
                        loading={isLoading}
                        educationMaterialPatients={
                            response && response.educationMaterialPatients
                                ? response.educationMaterialPatients
                                : []
                        }
                        pagination={paginationEducationList}
                    />
                </div>
            </Col>
            {sendModal && (
                <SendMaterialToPatient
                    sendModal={sendModal}
                    toggleModal={handelToggleModal}
                />
            )}
        </Row>
    );
}

export default EducationMaterialSentPatients;
